import { useMemo } from 'react';
import { SchedulerDayColumn } from '@lp/features/Scheduler/types';
import { getShiftSiblingsMap } from '@lp/features/Scheduler/utils';
import { getCCSiblingData } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/utils';
import { CCResource, CCResourcesWithShifts } from '@/api/apis/resources/schedule';

export const useCCShiftSiblingMaps = (
  dayCols: SchedulerDayColumn[],
  userList: CCResource[],
  shiftsData: CCResourcesWithShifts,
) => {
  const siblingMaps: Record<string, ReturnType<typeof getShiftSiblingsMap>> = useMemo(() => {
    return userList.reduce(
      (acc, u) => ({ ...acc, [u?.id]: getShiftSiblingsMap(dayCols, shiftsData[u?.id]?.days, getCCSiblingData) }),
      {},
    );
  }, [dayCols, userList, shiftsData]);

  return siblingMaps;
};
